// src/pages/stockTransfer/StockTransferA4Document.jsx
import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import A4DocumentLayout from '../../components/common/A4DocumentLayout/A4DocumentLayout';
import A4ProductCell from '../../components/common/A4DocumentLayout/A4ProductCell';
import { formatDate, formatDateTime } from '../../utils/dateUtils';
import { getTransferItemDisplayName, getTransferItemSku } from './transferItemUtils';

const warehouseCard = (title, warehouse) => ({
  title,
  primary: warehouse?.name || '-',
  lines: [warehouse?.address, warehouse?.phone].filter(Boolean),
});

const StockTransferA4Document = ({ transfer }) => {
  const { t } = useLocalization();

  if (!transfer) return null;

  const items = transfer.items || [];
  const isDraft = transfer.status === 'draft';

  return (
    <A4DocumentLayout
      title={transfer.Business?.name || t('stockTransfer.stockTransferNote')}
      subtitle={t('stockTransfer.stockTransferNote')}
      documentNumber={`#${transfer.transferNumber}`}
      metaRows={[
        { label: t('stockTransfer.transferDate'), value: formatDate(transfer.transferDate) },
        { label: t('stockTransfer.status'), value: isDraft ? t('stockTransfer.statusDraft') : t('stockTransfer.statusCompleted') },
        { label: t('stockTransfer.createdBy'), value: transfer.createdBy?.name || '-' },
        ...(transfer.completedBy
          ? [
              { label: t('stockTransfer.completedBy'), value: transfer.completedBy.name },
              { label: t('stockTransfer.completedAt'), value: formatDateTime(transfer.completedAt) },
            ]
          : []),
      ]}
      infoCards={[
        warehouseCard(t('stockTransfer.fromWarehouse'), transfer.fromWarehouse),
        warehouseCard(t('stockTransfer.toWarehouse'), transfer.toWarehouse),
      ]}
      items={{
        columns: [
          { header: '#', align: 'center', width: '40px' },
          { header: t('stockTransfer.product') },
          { header: t('stockTransfer.quantity'), align: 'right', width: '90px' },
        ],
        rows: [
          ...items.map((item, index) => [
            index + 1,
            <A4ProductCell item={item} name={getTransferItemDisplayName(item)} sku={getTransferItemSku(item)} />,
            parseFloat(item.quantity),
          ]),
          ['', <strong>{t('stockTransfer.totalItems')}: {items.length}</strong>, <strong>{parseFloat(transfer.totalQuantity || 0)}</strong>],
        ],
      }}
      summary={transfer.notes ? { notes: { label: t('stockTransfer.notes'), text: transfer.notes } } : undefined}
      footerNote={t('stockTransfer.computerGeneratedNote')}
    />
  );
};

export default StockTransferA4Document;
